// Instructions:
// Give the send button the className="send-button" otherwise the tooltip can't find the button
import { useTranslation } from 'react-i18next'

import { Tooltip } from 'primereact/tooltip'

import { CheckFieldOptions } from '../getMissingFieldsFromData'
import { MissingFieldsList } from './MissingFieldsList'

type Props = {
  missingFields: CheckFieldOptions[] | null
  areAllItemsRejected: boolean
  isEditModeOn: boolean
  configKey: string
}
export const CreateTooltip: React.FC<Props> = ({
  missingFields,
  areAllItemsRejected,
  isEditModeOn,
  configKey,
}) => {
  const { t } = useTranslation()

  // Count is needed to determine if singular
  // or plural translations are used
  const count =
    (missingFields ? missingFields.length : 0) +
    (areAllItemsRejected ? 1 : 0) +
    (isEditModeOn ? 1 : 0)

  return (
    <Tooltip target=".send-button" position="bottom" showOnDisabled>
      <ul className="my-1 pl-3">
        {isEditModeOn && <li>{t('common.tooltips.saveYourChanges')}</li>}
        {areAllItemsRejected && (
          <li>{t('common.tooltips.allItemsAreRejected')}</li>
        )}

        {missingFields && (
          <>
            <li>
              {t('common.tooltips.missingField', {
                count: count,
              })}
            </li>
            <MissingFieldsList
              missingFields={missingFields}
              configKey={configKey}
            />
          </>
        )}
      </ul>
    </Tooltip>
  )
}
